import { AsyncPipe } from '@angular/common';
import { Component, HostBinding, inject } from '@angular/core';
import { ButtonModule } from '@bcef/ia-components/buttons';
import { IconsModule } from '@bcef/ia-ng-icons';
import { DataLayered } from '@difa/ia-data-layer';
import { TranslateModule } from '@ngx-translate/core';

import { SuccessionFacade } from '@features/succession/succession.facade';

@DataLayered('dataLayer.confirmation')
@Component({
  selector: 'ia-succession-confirmation',
  templateUrl: './confirmation.component.html',
  imports: [AsyncPipe, ButtonModule, IconsModule, TranslateModule],
  standalone: true,
})
export class ConfirmationComponent {
  @HostBinding('class') public classAttribute = 'tw-flex tw-flex-col tw-mb-4 sm:tw-mx-24';

  public readonly successionFacade = inject(SuccessionFacade);

  public onNext(): void {
    this.successionFacade.confirmation();
  }
}
